module.exports = __webpack_public_path__ + "assets/brightcove.55b79be5.svg";